import { cva } from 'class-variance-authority'
import { NavLink, useMatch } from 'react-router-dom'

import { cn } from '@/utils/cn'

import type { NavItem } from '@/config/navigation'

interface PropsI extends Omit<NavItem, 'children'> {
  className?: string
}

const navItemCls = cva(
  'group/navItem focus-visible:ring-2 focus-visible:ring-elements-dark-highlight flex items-center justify-between px-2 py-2 text-sm font-medium outline-none rounded-md transition-colors',
  {
    variants: {
      active: {
        true: 'bg-elements-dark-dimmed text-elements-dark-contrastText hover:bg-elements-dark-dimmed',
        false:
          'text-elements-dark-contrastText/70 hover:bg-elements-dark-dimmed hover:text-elements-dark-contrastText',
      },
    },
    defaultVariants: { active: false },
  },
)

export const navItemIconCls = cva('mr-3 h-5 w-5 transition-colors', {
  variants: {
    active: {
      true: 'text-elements-dark-contrastText',
      false:
        'text-elements-dark-contrastText/50 group-hover/navItem:text-elements-dark-contrastText',
    },
  },
  defaultVariants: { active: false },
})

const NavigationItem = ({ label, icon: Icon, url, className }: PropsI) => {
  const isActive = !!useMatch({ path: url, end: true })

  return (
    <NavLink
      to={url}
      className={cn(navItemCls({ active: isActive }), className)}
    >
      <span className='inline-flex items-center'>
        <Icon className={navItemIconCls({ active: isActive })} />
        {label}
      </span>
    </NavLink>
  )
}

export default NavigationItem
